import PropTypes from 'prop-types';
import React from 'react';
import config from '../../config';
import DateField from '../DateField/index';
import { isMoment } from 'moment';
import './style.scss';
import Field from 'components/Field';

class DateTimeField extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dateMomentValue: null,
      dateStringValue: null,
      timeStringValue: null,
      fullDateStr: null,
    };
  }

  saveFormVal = () => {
    this.props.input.onChange(this.state.fullDateStr);
  };
  saveFullDateStr = () => {
    const secondsVal = '00';
    const dateStr = `${this.state.dateStringValue} ${this.state.timeStringValue}:${secondsVal}`;
    const regExpDateAndTime = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
    const isValidDate = regExpDateAndTime.test(dateStr);
    isValidDate
      ? this.setState({ fullDateStr: dateStr }, this.saveFormVal)
      : this.setState({ fullDateStr: null }, this.saveFormVal);
  };
  dateHandlerOnChange = (val) => {
    this.setState(
      {
        dateMomentValue: val,
        dateStringValue: isMoment(val) ? val.format(config.serverDatetimeFormat) : null,
      },
      this.saveFullDateStr,
    );
  };
  dateHandlerOnBlur = (val) => {
    // onBlur for required func
    const saveOnBlur = () => {
      this.saveFullDateStr();
      this.props.input.onBlur(this.state.fullDateStr);
    };
    if (isMoment(val)) {
      this.setState({ dateStringValue: val.format(config.serverDatetimeFormat) }, saveOnBlur);
    } else this.setState({ dateStringValue: null }, saveOnBlur);
  };
  timeHandlerOnChange = (val) => {
    this.setState({ timeStringValue: val }, this.saveFullDateStr);
  };

  render() {
    const {
      input,
      meta: { touched, error, warning },
      ...args
    } = this.props;
    const validationMessage = touched ? error || warning : null;
    const clearedValidationMessage = touched ? <div /> : null;
    const isValid = !(error || warning);
    const id = args.id || input.name || null;
    return (
      <div>
        <DateField
          {...args}
          {...input}
          label={'Дата и время'}
          handleChangeStart={this.dateHandlerOnChange}
          onBlur={this.dateHandlerOnBlur}
          startDateValue={this.state.dateMomentValue}
          validationMessage={validationMessage}
          isValid={isValid}
          id={id}
          classNameWrapper={'date-time-wrapper'}
        >
          <Field
            className={'date-time-wrapper__time-input'}
            isValid={isValid}
            validationMessage={clearedValidationMessage}
            mask={'11:11'}
            isRequired={args.isRequired}
            value={this.state.timeStringValue}
            onChange={(event) => this.timeHandlerOnChange(event.target.value)}
          />
        </DateField>
      </div>
    );
  }
}

DateTimeField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }),
};

export default DateTimeField;
